export { HttpPinterestService } from './HttpPinterestService';
